(function() {
    angular
        .module("app")
        .factory("notesService", notesService)

        notesService.$inject = [
        "$rootScope",
        "$http",
        "$sce"
    ]

    function notesService(
        $rootScope,
        $http,
        $sce
    ) {

        let service = {}

        service.formatContentForDisplay = (text) => {
            return $sce.trustAsHtml(text.replaceAll("\n", "<br/>").replaceAll("<scri", "scri").replaceAll("&lt;scri", "scri"))
        }

        service.createNote = function(ownerID, ownerType, text, priv, successCallback, failureCallback) {

            const success = (response) => {
                if (successCallback !== undefined) {
                    successCallback(response.data)
                }
            }

            const failure = (error) => {
                console.error(error)
                if (failureCallback !== undefined) {
                    failureCallback(error)
                }
            }

            $http({
                method: "POST",
                url: $rootScope.config.apiUrl + "/notes",
                data: {
                    component_id:   ownerID,
                    component_type: ownerType,
                    text:           text,
                    private:        priv
                }
            }).then(success, failure)
        }

        service.deleteNote = function(noteID, successCallback, failureCallback) {

            const success = (response) => {
                if (successCallback !== undefined) {
                    successCallback(response.data)
                }
            }

            const failure = (error) => {
                console.error(error)
                if (failureCallback !== undefined) {
                    failureCallback(error)
                }
            }

            $http({
                method: "DELETE",
                url: $rootScope.config.apiUrl + "/notes/" + noteID
            }).then(success, failure)
        }

        return service
    }
})()
